import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      d: "m20 20-5.333-5.333M4 10.222a6.223 6.223 0 1 0 12.446 0 6.223 6.223 0 0 0-12.446 0Z"
    }, null, -1)
  ])))
}
export default { render: render }